



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { IRecipient } from '@lib-shared/types/Recipient';

@Component
export default class SigningOptions extends Vue {
  @Prop({ default: [] }) recipients: IRecipient[];
  @Prop() newCommentsCount: number;
  @Prop() chatEnabled: boolean;

  handleOpenRecipients() {
    this.$emit('recipients');
  }

  handleToggleChat() {
    this.$emit('chat');
  }

  handleToggleMenu() {
    this.$emit('menu');
  }
  get newChatComments(): boolean {
    return this.newCommentsCount > 0;
  }

  handleHelp() {
    window.open(
      'http://help.getaccept.com/en/articles/4175027-issues-related-to-document',
      '_blank'
    );
  }
}
